var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[_c('Introduction'),_c('WorkExperience'),_c('CaseStudies'),_c('ToolsOfTrade'),_c('ArtStuff'),_c('Other'),_c('Photos'),_c('Contact'),_c('footer',[_vm._v("2024 - Daniel Hodvogner")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }